<template>

	<div>

		<div class="portlet light inbox-body">

			<div class="portlet-title">

				<div class="caption">

					<i class="icon-bubble font-hide hide"></i>

					<span class="caption-subject font-hide bold uppercase">
						{{ messageGroup.subject }}
					</span>

					<br>

					<span class="caption-helper" v-if="messageGroup.student">
						<span v-translate>Aluno:</span>
						{{ messageGroup.student.name }}
						<span v-if="messageGroup.student.schoolClass">
							({{ messageGroup.student.schoolClass.description }})
						</span>
					</span>

				</div>

			</div>

			<div class="portlet-body">

				<div class="row">

					<div class="col-md-8">

						<ol class="chats">

							<li :class="{ 'out' : loggedUserId === msg.from.userId, 'in': loggedUserId !== msg.from.userId }" v-for="msg in messages">

								<img class="avatar img-thumbnail" :src="msg.from.photoURL">

								<div class="message">

									<span class="arrow"> </span>
									<span class="name">{{ msg.from.name }}</span>
									<span class="datetime">às {{ msg.sentDateTime | date("DD/MM/YYYY HH:mm") }}</span>
									<strong class="body">{{ msg.message }}</strong>

									<br>

									<popover placement="right" title="Mensagem lida por" width="350" trigger="hover" v-if="msg.usersRead" >

										<button type="button" class="btn btn-xs" slot="reference">
											<i class="fa fa-eye" aria-hidden="true"></i>
											{{ msg.status | enum('MessageStatusType') }}
										</button>

										<ul class="list-group">
											<li class="list-group-item" v-for="(user, index) in msg.usersRead">
												{{ user.userName }}
												<br>
												<span class="text-muted">em {{ user.readDateTime | date("DD/MM/YYYY hh:MM:ss") }})</span>
											</li>
										</ul>

									</popover>

								</div>

							</li>

						</ol>

						<form class="chat-form" v-on:submit.prevent="send">

							<div class="input-cont emoji-text relative">

								<textarea class="form-control" id="readMessageContent" v-model="message" placeholder="Escreva sua mensagem aqui..." rows="4"></textarea>
								<picker v-show="emojiPickerVisible" class="absolute" :exclude="['flags', 'symbols']" :i18n="i18n" title="Emoji" set="apple" @click="addEmoji"></picker>

							</div>

							<div class="btn-cont">

								<button type="submit" class="btn green-jungle icn-only" id="readMessageSend">
									<i class="fa fa-paper-plane-o" aria-hidden="true"></i>
									<span v-translate>Enviar</span>
								</button>

							</div>

							<button type="button" class="btn green m-t-10" @click="emojiPickerVisible = !emojiPickerVisible">
								<emoji emoji="grinning" :size="15"></emoji>
								Emojis
							</button>

							<p class="text-muted">
								<small v-translate>Para usar <em>emojis</em> clique no botão acima.</small><br>
								<small v-translate><strong>Observação:</strong> no navegador os <em>emojis</em> podem aparecer em forma de [], mas ao enviar aparecerá o <em>emoji</em> selecionado.</small>
							</p>

						</form>

					</div>

					<div class="col-md-4">

						<message-users v-if="messageGroupUsers" :users="messageGroupUsers" />

					</div>

				</div>

			</div>

		</div>

	</div>

</template>

<style lang="scss" scoped>

	.chats {

		li {

			&.out {
				.message {
					border-right-color: #0084bf;
					.arrow {
						border-left-color: #0084bf;
					}
				}
			}

			&.in {
				.message {
					border-left-color: #ff8900;
					.arrow {
						border-right-color: #ff8900;
					}
				}
			}

			.body {
				font-size: 13px;
				color: #666;
			}

		}

	}

	.img-thumbnail {
		padding: 0;
	}

	.chat-form {

		overflow: initial;

		.input-cont {
			margin-right: 85px;
		}

		.btn-cont {

			width: 85px;
			height: 94px;
			margin-top: -101px;

			.btn {
				height: 94px;
			}

			&:hover,
			&:focus {

				.btn {
					background-color: #1e9765;
					border-color: #1c8f5f;
					height: 94px;
				}

			}

		}

	}

	.table {
		margin: 0;
	}

	.portlet-participants {

		.table-hover tbody tr:hover>td,
		.table-hover tbody tr:hover>th,
		.table-striped tbody>tr:nth-child(odd)>td,
		.table-striped tbody>tr:nth-child(odd)>th {
			cursor: default;
		}

	}

</style>

<script>

	import MessageReply from './';
	export default MessageReply;

</script>



// WEBPACK FOOTER //
// message-reply.vue?71c1c0f7